import { cn } from '@/lib/utils';
import type { ConnectorGate } from '@/data/copilot';
import { connectorGateNotice } from './contentActionModel.ts';

/* ----------------------------------------------------------------------------
 * The honest gated-connectors notice (P3 Lane 3D). Aura prepares DRAFTS only —
 * publishing, scheduling and sending are not connected. This is a purely
 * informational strip: it renders NO active control, so no publish/schedule/
 * send button can exist here by construction (invariant 5).
 * -------------------------------------------------------------------------- */
export function ConnectorGatedNotice({
  connectors,
  className,
}: {
  connectors?: ConnectorGate | null;
  className?: string;
}) {
  const { note } = connectorGateNotice(connectors);
  return (
    <div
      role="note"
      aria-label="Publishing and sending are not connected"
      className={cn(
        'flex items-start gap-2 rounded-md border border-border-subtle bg-inset px-3 py-2 text-[11px] leading-snug text-text-secondary',
        className,
      )}
    >
      <span aria-hidden className="mt-[1px] text-text-tertiary">
        &#128274;
      </span>
      <span>
        <span className="font-semibold text-text-tertiary">Draft only · </span>
        {note}
      </span>
    </div>
  );
}
